import { render } from "./DisplayFilesGalleria.vue?vue&type=template&id=8084133a"
import script from "./DisplayFilesGalleria.vue?vue&type=script&lang=js"
export * from "./DisplayFilesGalleria.vue?vue&type=script&lang=js"

import "./DisplayFilesGalleria.vue?vue&type=style&index=0&id=8084133a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__